// extracted by mini-css-extract-plugin
export default {"avatar":"avatar__avatar___Bt9id","initials":"avatar__initials___Qx8IC","userPic":"avatar__userPic___pHdoa"};